import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { UserAvatar, Icon } from 'appSrc/components/UI';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/PlayIcon';
import style from './styles/style.module.css';

class LargeListCard extends PureComponent {
    constructor( props ) {
        super( props );

        const { list } = props;

        let author = list.author || {};

        this.state = {
            listSlug: '/' + author.slug + '/' + list.slug,
            hasVideo: !!list.youtube,
        };
    }
    renderCoverImage = ( list ) => {
        var coverImage = list.coverImage || convertYouTubeIdToImg( list.youtube );
        return (
            <ListCoverImage coverImage={ coverImage } />
        );
    }
    render() {
        const { list } = this.props;
        const { listSlug, hasVideo } = this.state;

        const author = list.author || {};
        const profession = ( author.profession || {} ).title;

        const desires = list.desires || [];
        const interests = list.interests || [];

        const movieMetaData = {
            attached_to: 'list_cover_video',
            attached_id: list.listid,
            video_author_id: author.userid,
        };
        var countMessage = desires.length.toString() + ' Product';
        countMessage += desires.length > 1 ? 's' : '';

        return (
            <div className={ `${ style.largeListCard } ${ this.props.className }`.trim() }>
                <Link to={ listSlug } className={ style.backgroundLink }></Link>
                <div className={ style.cardContent }>
                    <AspectRatio
                    ratio='16/9'>
                        <div className={ style.imageWrapper }>
                            { this.renderCoverImage( list ) }
                            <div className={ style.overlayInfo }>
                                <div className={ style.authorInfo }>
                                    <UserAvatar src={ author.avatar } size={ 35 } />
                                    <div className={ style.infoText }>
                                        { profession &&
                                            <div className={ style.profession }>{ profession }</div>
                                        }
                                        <div className={ style.displayName }>{ author.displayName }</div>
                                    </div>
                                </div>
                                { hasVideo &&
                                    <TheaterPlayIcon className={ style.playButton } youtubeId={ list.youtube }
                                    metaData={ movieMetaData } />
                                }
                                <div className={ style.productCount }>
                                    <Icon source='customSvg' icon='bag' size={ 16 } />
                                    <span>{ countMessage }</span>
                                </div>
                            </div>
                        </div>
                    </AspectRatio>
                    <div className={ style.cardInfo }>
                        <div className={ style.listCategory }>{ ( interests[0] || {} ).interest }</div>
                        <TextTruncate text={ list.title }
                        title={ list.title } line={ 2 }
                        containerClassName={ style.listTitle } />
                    </div>
                </div>
            </div>
        );
    }
}
LargeListCard.propTypes = {
    list: PropTypes.object.isRequired,
};
LargeListCard.defaultProps = {
    className: '',
};

export default LargeListCard;
